module.exports = __webpack_public_path__ + "d87f37311b6b2bb612040e2a3712764f.pdf";